import { Container, Typography } from '@mui/material'
import React from 'react'
import styles from './trackingGuideDetailsStyles'

const TrackingGuideDetails = ({guide}) => {
  return (
    <Container style={styles.mainContainer}>
      <Typography variant="h6" sx={styles.title}>Detalles del paquete</Typography>
      <Container sx={styles.secondaryContainer}>
        <Container sx={styles.sectionContainer}>
          <Typography variant="body2">Medidas</Typography>
          <Typography variant="subtitle1" sx={styles.data}>
            {guide?.guide_info?.package_info?.package_height ?? '?'} x {guide?.guide_info?.package_info?.package_length ?? '?'} x {guide?.guide_info?.package_info?.package_width ?? '?'}
          </Typography>
        </Container>
      </Container>
      <Container sx={styles.rowContainer}>
        <Container sx={styles.sectionContainer}>
          <Typography variant="body2">Peso (kg)</Typography>
          <Typography variant="subtitle1" sx={styles.data}>{guide?.guide_info?.package_info?.package_weight ?? '?'}</Typography>
        </Container>
        <Container sx={styles.sectionContainer}>
          <Typography variant="body2">Zona</Typography>
          <Typography variant="subtitle1" sx={styles.data}>{guide?.guide_info?.zone_info?.zone ?? '?'}</Typography>
        </Container>
        <Container sx={styles.sectionContainer}>
          <Typography variant="body2">Aréa</Typography>
          <Typography variant="subtitle1" sx={styles.data}>{guide?.guide_info?.zone_info?.area ?? '?'}</Typography>
        </Container>
      </Container>
      <Container sx={styles.rowContainer}>
        <Container sx={styles.sectionContainer}>
          <Typography variant="body2">Sector</Typography>
          <Typography variant="subtitle1"sx={styles.data}>{guide?.guide_info?.zone_info?.sector ?? '?'}</Typography>
        </Container>
        <Container sx={styles.sectionContainer}>
          <Typography variant="body2">Subsector</Typography>
          <Typography variant="subtitle1" sx={styles.data}>{guide?.guide_info?.zone_info?.subsector ?? '?'}</Typography>
        </Container>
      </Container>
      {/* {((guide?.guide_info?.package_info?.extra_weight != null && guide?.guide_info?.package_info?.extra_weight !== 0) || 
        (guide?.guide_info?.package_info?.extra_weight_cost != null && guide?.guide_info?.package_info?.extra_weight_cost !== 0)) && (
        <Container sx={styles.rowContainer}>
          {guide?.guide_info?.package_info?.extra_weight != null && guide?.guide_info?.package_info?.extra_weight !== 0 && (
            <Container sx={styles.extraSectionContainer}>
              <Typography variant="body2">Peso extra (kg)</Typography>
              <Typography variant="subtitle1" sx={styles.data}>{guide.guide_info.package_info.extra_weight}</Typography>
            </Container>
          )}
          {guide?.guide_info?.package_info?.extra_weight_cost != null && guide?.guide_info?.package_info?.extra_weight_cost !== 0 && (
            <Container sx={styles.extraSectionContainer}>
              <Typography variant="body2">Costo extra</Typography>
              <Typography variant="subtitle1" sx={styles.data}>${guide.guide_info.package_info.extra_weight_cost}</Typography>
            </Container>
          )}
        </Container>
      )} */}
    </Container>
  )
}

export default TrackingGuideDetails